import React from 'react';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import { routerProps } from '../../../propTypes';

import PageLayout from '../../../layouts/PageLayout';
import PerDiemApprovalsTable from '../components/PerDiemApprovalsTable';
import { setPerDiemState } from '../actions';

const PENDING_STATE = 'pending';

const propTypes = exact({
  setPerDiemStateAction: PropTypes.func.isRequired,
  ...routerProps,
});


const PerDiemApprovalPage = (props) => {
  return (
    <PageLayout
      title="Pending Per Diem Approvals"
      render={() => { return <PerDiemApprovalsTable />; }}
    />
  );
};

PerDiemApprovalPage.propTypes = propTypes;

const withInitPage = lifecycle({
  componentWillMount() {
    const { setPerDiemStateAction } = this.props;
    setPerDiemStateAction(PENDING_STATE);
  },
});

const mapDispatchToProps = {
  setPerDiemStateAction: setPerDiemState,
};

const withRedux = connect(null, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withInitPage,
);

export default enhance(PerDiemApprovalPage);
